import { baseUrl, getKmsData } from "@kaltura/mediaspace-shared-utils";
import { StatusesMapper, UploadStatus } from "@kaltura/mediaspace-shared-upload";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";
import { KalturaEntryStatus } from "kaltura-typescript-client/api/types/KalturaEntryStatus";
import { AddEntrySaveResponse } from "../types";

export const deleteEntry = async (entryId: string): Promise<void> => {
    await getKmsData(`${baseUrl}/addfromurl/index/delete-entry?id=${entryId}`);
};

// Fetches the latest status for an entry and maps it to UploadStatus.
// Returns null when the backend response is missing or invalid.
export const checkAddFromUrlEntryStatus = async (
    entryId: string
): Promise<{ entry: KalturaMediaEntry; uploadStatus: UploadStatus } | null> => {
    const url = `${baseUrl}/addfromurl/index/check-status?entryId=${entryId}`;
    const result: AddEntrySaveResponse = await getKmsData(url);

    if (!result.status || !result.entry) {
        return null;
    }

    const entry = result.entry as KalturaMediaEntry;
    const kalturaStatus = entry.status as KalturaEntryStatus;
    const statusKey = (StatusesMapper[kalturaStatus] ?? "ENTRY_FAILED") as keyof typeof UploadStatus;
    const uploadStatus = UploadStatus[statusKey];

    return { entry, uploadStatus };
};
